export default "__VITE_ASSET__BcYg4kBX__"